import {
	createStore,
	createHook,
	createActionsHook,
	type BoundActions,
	type HookActionsFunction,
	type HookFunction,
	type StoreActionApi,
} from 'react-sweet-state';

export interface GeneratedTitleState {
	generatedTitle: string;
	trackAIResultViewStored: (attribute: any) => void;
	// For title generation on paste (standard pages only)
	generatedTitleFromPaste: string;
	fireResultAnalyticsFromPaste: () => void;
}

export const initialState: GeneratedTitleState = {
	generatedTitle: '',
	trackAIResultViewStored: () => {},
	generatedTitleFromPaste: '',
	fireResultAnalyticsFromPaste: () => {},
};

const NAME = 'GENERATED_TITLE_STORE';

export const actions = {
	setGeneratedTitle:
		(newTitle: string) =>
		({ setState }: StoreActionApi<GeneratedTitleState>): void => {
			setState({ generatedTitle: newTitle });
		},
	setTrackAIResultViewStored:
		(trackAIResultViewHook: (attribute: any) => void) =>
		({ setState }: StoreActionApi<GeneratedTitleState>): void => {
			setState({ trackAIResultViewStored: trackAIResultViewHook });
		},
	setGeneratedTitleFromPaste:
		(newTitle: string) =>
		({ setState }: StoreActionApi<GeneratedTitleState>): void => {
			setState({ generatedTitleFromPaste: newTitle });
		},
	setFireResultAnalyticsFromPaste:
		(fireResultAnalytics: () => void) =>
		({ setState }: StoreActionApi<GeneratedTitleState>): void => {
			setState({ fireResultAnalyticsFromPaste: fireResultAnalytics });
		},
	clearGeneratedTitleFromPaste:
		() =>
		({ setState }: StoreActionApi<GeneratedTitleState>): void => {
			setState({ generatedTitleFromPaste: '', fireResultAnalyticsFromPaste: () => {} });
		},
};

const GeneratedTitleStore = createStore({
	name: NAME,
	initialState,
	actions,
});

export const useGeneratedTitle: HookFunction<
	GeneratedTitleState,
	BoundActions<
		GeneratedTitleState,
		{
			setGeneratedTitle: (
				newTitle: string,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			setTrackAIResultViewStored: (
				trackAIResultViewHook: (attribute: any) => void,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			setGeneratedTitleFromPaste: (
				newTitle: string,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			setFireResultAnalyticsFromPaste: (
				fireResultAnalytics: () => void,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			clearGeneratedTitleFromPaste: () => ({
				setState,
			}: StoreActionApi<GeneratedTitleState>) => void;
		}
	>,
	void
> = createHook(GeneratedTitleStore);
export const useGeneratedTitleActions: HookActionsFunction<
	BoundActions<
		GeneratedTitleState,
		{
			setGeneratedTitle: (
				newTitle: string,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			setTrackAIResultViewStored: (
				trackAIResultViewHook: (attribute: any) => void,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			setGeneratedTitleFromPaste: (
				newTitle: string,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			setFireResultAnalyticsFromPaste: (
				fireResultAnalytics: () => void,
			) => ({ setState }: StoreActionApi<GeneratedTitleState>) => void;
			clearGeneratedTitleFromPaste: () => ({
				setState,
			}: StoreActionApi<GeneratedTitleState>) => void;
		}
	>
> = createActionsHook(GeneratedTitleStore);
